<script lang="ts" setup>
import { useAccountMenu } from '@/composables/useAccountMenu'
import store from '@/store'

/** App-bar menu item (staff only, while not impersonating) linking to the impersonation page. */
const { isStaff } = useAccountMenu()
</script>

<template>
  <v-list-item v-if="!store.getters.user.impersonator && isStaff()" to="/impersonate">
    <v-list-item-title>Impersonate</v-list-item-title>
    <template #append>
      <v-icon>mdi-incognito</v-icon>
    </template>
  </v-list-item>
</template>
